import { getContext, setContext } from 'svelte'
import type { LocaleStoreContent } from '../stores/locale';
import type { CollectionStore } from '../stores/collection';

type CreateContextReturn<T> = [(opts: T) => void, (fallback?: T) => T, symbol]

const createContext = <T>(id: string) => {
  const provider = (value: T) => setContext(id, value);
  const consumer = () => getContext(id);
  return [provider, consumer, Symbol(id)] as CreateContextReturn<T>;
}

export const [setLocaleContext, useLocaleContext] = createContext<LocaleStoreContent>('locale-context')

export const [setCollectionContext, useCollectionContext] = createContext<CollectionStore>('locale-context');
